// import React, { createContext, useContext, useState, ReactNode, useEffect, useMemo, useRef } from "react";
// import marker from "../../../src/assests/images/marker_black.svg";
// import { useParams } from "react-router-dom";

// // Interfaces for TaskContext
// interface SectionData {
//   value?: string;
//   id: number;
//   initialName: string;
//   placeholder: string;
//   markerImage: string;
//   typographyText: string;
//   textValue: string;
//   textValue_hi: string;
//   language: string;
//   iconimage: string;
//   mainplaceholder: string;

//   selectValue: string;
//   smallquestionsimage: string[];
//   optionsslectedvalue: string | null;
//   finalcorr?: string;
//   correcthint: string;
//   correcthint_hi: string;
//   idid1: number;
//   taskinstructions: { id: number; value: string; image: string }[];
//   taskimage: string;
//   test245: string;

//   dropdownOptions: { id: number; label: string; value: string }[];
//   instructions: { id: number; value: string; value_hi: string; smallimage: string; bigimage: string }[];
//   Multiples: { id: number; value: string; value_hi: string; checkvalue: string; smallimage: string; bigimage: string; ismatch?: boolean }[];
//   Checkboxes: { id: number; value: string; checked: boolean }[];
//   rating: { initialStars: number; maxStarsOptions: number[] };
// }
// interface FileItem {
//   id: number;
//   file: File;
//   preview: string;

// }
// type FileItem22 = {
//   id: number;
//   file?: File;       // optional now
//   preview: string;
//   imageUrl: string;
// };
// interface MultipleItem {
//   id: number;
//   value: string;
//   value_hi: string;
//   checkvalue: string;
//   smallimage: string;
//   bigimage: string;
//   ismatch?: boolean;
// }

// interface CheckboxItem {
//   id: number;
//   value: string;
//   value_hi: string; // Added value_hi field
//   checked: boolean;
//   idid: number;
//   smallimage: string;
//   bigimage: string;
// }

// interface FileItem1 {
//   id: number;
//   file: File;
//   preview: string;
//   imageUrl: string

// }


// interface MulitipleItem {
//   id: number;
//   value: string;
//   checkvalue: string;
//   smallimage: string, bigimage: string
//   ismatch: false
// }
// type Item = { id: number; value: string; idid: number };
// interface AllTasksProviderProps {
//   children: React.ReactNode;
//   currentLang: any; // Adjust type accordingly (string, object, etc.)
// }
// interface TaskState {
//   instructions: { id: number; value: string; image: string }[];
//   idid: number;
//   textname: string;
//   multiples: MulitipleItem[]; // Ensure the correct type
//   selectedValue: string | null;
//   text: string
//   sectionsData: number
// }
// type InstructionImageMapType = {
//   mainId: number;
//   instructionId: number;
//   image: string;
// };

// interface TaskContextType {
//   showNoTask: boolean;
//   setShowNoTask: (value: boolean) => void;

//   sectionsData: SectionData[];
//   setSectionsData: React.Dispatch<React.SetStateAction<SectionData[]>>;
//   Tabname: string;

//   setTabname: (value: string) => void;
//   setfinalvalue: (value: string) => void;

//   setfileName: (value: string) => void;
//   fileName: string
//   finalvalue: string
//   targetData: SectionData[];
//   test22: string
//   finalll: string[]
//   correctHintArray: { id: number; index: number; value: string }[];
//   setCorrectHintArray: React.Dispatch<React.SetStateAction<{ id: number; index: number; value: string }[]>>;
//   correctHintHiArray: { id: number; index: number; value: string }[];
//   setCorrectHintHiArray: React.Dispatch<React.SetStateAction<{ id: number; index: number; value: string }[]>>;

//   textValueData: { id: number; value: string }[];
//   setTextValueData: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;

//   textValueDatadefault: { id: number; value: string }[];
//   setTextValueDatadefault: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;

//    textValueDatadefaulthindi: { id: number; value: string }[];
//   setTextValueDatadefaulthindi: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;


//   textValueData44: { id: number; value: string }[];
//   setTextValueData44: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;


//   textValueHiData: { id: number; value: string }[];
//   setTextValueHiData: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;

//   instructionImageMap: InstructionImageMapType[];
//   setInstructionImageMap: React.Dispatch<
//     React.SetStateAction<InstructionImageMapType[]>
//   >;


//   valueArray: { mainid: number; index: number; value: string }[];
//   setValueArray: React.Dispatch<React.SetStateAction<{ mainid: number; index: number; value: string }[]>>;
//   valueHiArray: { mainid: number; index: number; value: string }[];
//   setValueHiArray: React.Dispatch<React.SetStateAction<{ mainid: number; index: number; value: string }[]>>;

//   setfinalll: (value: string[]) => void;
//   settest22: (value: string) => void;
//   settargetData: React.Dispatch<React.SetStateAction<SectionData[]>>;
//   selectedmcq: string;
//   setSelectedmcq: (value: string) => void;

//   selectedmcq22: Record<number, string>;
//   setSelectedmcq22: React.Dispatch<React.SetStateAction<Record<number, string>>>;

// defaultipostermages: string[];
//   setdefaultipostermages: React.Dispatch<React.SetStateAction<string[]>>;


  
// defaulttaskiconimages: string[];
//   setdefaulttaskiconimages: React.Dispatch<React.SetStateAction<string[]>>;



  
// selectedOption1: string;
//   setSelectedOption1: React.Dispatch<React.SetStateAction<string>>;
//   educationalData: SectionData[];
//   seteducationalData: React.Dispatch<React.SetStateAction<SectionData[]>>;
//   state: TaskState;
//   setState: React.Dispatch<React.SetStateAction<TaskState>>;
//   addQuestionss: (tabName: any) => void;
//   showImageUploadBanner: boolean;
//   setShowImageUploadBanner: (value: boolean) => void;
//   currentLang: string,



//   checkboxItems: { [key: number]: CheckboxItem[] }; // Updated type
//   setCheckboxItems: React.Dispatch<React.SetStateAction<{ [key: number]: CheckboxItem[] }>>; // Updated type
//   setCurrentLang: (lang: string) => void;
//   instructions33: InstructionItem[];
//   instructions33default:InstructionItem[];
//   imagesdata: { id: number; images: string[] }[];
//   setimagesdata: React.Dispatch<React.SetStateAction<{ id: number; images: string[] }[]>>;
//   imagesdata3: { id: number; images: string[] }[];
//   setimagesdata3: React.Dispatch<React.SetStateAction<{ id: number; images: string[] }[]>>;
//   imagesdata1: { id: number; images: string[] }[];
//   setimagesdata1: React.Dispatch<React.SetStateAction<{ id: number; images: string[] }[]>>;
//   activeStep: number;
//   setActiveStep: React.Dispatch<React.SetStateAction<number>>;
//   setInstructions: React.Dispatch<React.SetStateAction<InstructionItem[]>>;

//   setInstructionsdefault: React.Dispatch<React.SetStateAction<InstructionItem[]>>;

  



//   test22Value: Record<number, string>;
//   setTest22Value: React.Dispatch<React.SetStateAction<Record<number, string>>>;
//   stepOneMultiples: MulitipleItemdd[];
//   setStepOneMultiples: React.Dispatch<React.SetStateAction<MulitipleItemdd[]>>;
//   currentData: any;
//   setCurrentData: React.Dispatch<React.SetStateAction<any>>;
//   currentlength: number;
//   setcurrentlength: React.Dispatch<React.SetStateAction<number>>;
//   multiples888: any[];
//   setMultiples888: React.Dispatch<React.SetStateAction<any[]>>;

//   multiples99: any[];
//   setMultiples2299: React.Dispatch<React.SetStateAction<any[]>>;

//   combinedMultiplesState: typeof defaultCombinedMultiples;
//   setCombinedMultiplesState: React.Dispatch<React.SetStateAction<typeof defaultCombinedMultiples>>;

//   files: FileItem[];
//   setFiles: React.Dispatch<React.SetStateAction<FileItem[]>>;
//   longDescriptions: { [key: string]: string };
//   setLongDescriptions: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;

//   files3: FileItem[];
//   setFiles3: React.Dispatch<React.SetStateAction<FileItem[]>>;


//   selectedItems: Item[];
//   setSelectedItems: React.Dispatch<React.SetStateAction<Item[]>>;


//   files2: FileItem22[];
//   setFiles2: React.Dispatch<React.SetStateAction<FileItem22[]>>;
//   longDescriptionsHi: { [key: string]: string }; // New state for Hindi descriptions
//   setLongDescriptionsHi: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;

//   //    files4: FileItem1[];
//   // setFiles4: React.Dispatch<React.SetStateAction<FileItem1[]>>;

//   files4: { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[];
//   setFiles4: React.Dispatch<
//     React.SetStateAction<
//       { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[]
//     >
//   >

//   transfer22: any;
//   settransfer22: React.Dispatch<React.SetStateAction<any>>;
//   uploadedImages: { [key: number]: string };
//   setUploadedImages: React.Dispatch<React.SetStateAction<{ [key: number]: string }>>;
//   // sectionsData22: SectionData[];
//   // setSectionsData22: React.Dispatch<React.SetStateAction<SectionData[]>>;

//   step1data: any[];
//   setstep1data: React.Dispatch<React.SetStateAction<any[]>>;

//   alldefaultvalues: any[];
//   setdefaultvalues: React.Dispatch<React.SetStateAction<any[]>>;


//   step1data2: any[];
//   setstep1data2: React.Dispatch<React.SetStateAction<any[]>>;


  

//   step1data2default: any[];
//   setstep1data2default: React.Dispatch<React.SetStateAction<any[]>>;


//     step1data2defaultchekbox: any[];
//   setstep1data2defaultchekbox: React.Dispatch<React.SetStateAction<any[]>>;

//   allinone: any[], setallinone: React.Dispatch<React.SetStateAction<any[]>>;


//     allhintsteps: any[], setallhitssteps: React.Dispatch<React.SetStateAction<any[]>>;


// }

// // Create Contexts
// const TaskContext = createContext<TaskContextType | undefined>(undefined);
// interface InstructionItem {
//   media?: any;
//   id: number;
//   value: string;
//   value_hi: string
//   smallimage: string;
//   bigimage: string
// }

// interface MulitipleItemdd {
//   value_hi: unknown;
//   id: number;
//   value: string;
//   checkvalue: string;
//   smallimage: string
//   bigimage: string
//   mainid: number;
// }

// const defaultCombinedMultiples = [
//   {
//     id: 1,
//     value: "",
//     value_hi: "",
//     checkvalue: "check1",
//     smallimage: "",
//     bigimage: "",
//     mainid: 1,
//     ismatch: false
//   },
//   {
//     id: 2,
//     value: "",
//     value_hi: "",
//     checkvalue: "check2",
//     smallimage: "",
//     bigimage: "",
//     mainid: 1,
//     ismatch: false
//   },
//   {
//     id: 3,
//     value: "",
//     value_hi: "",
//     checkvalue: "check3",
//     smallimage: "",
//     bigimage: "",
//     mainid: 1,
//     ismatch: false
//   },
//   {
//     id: 4,
//     value: "",
//     value_hi: "",
//     checkvalue: "check4",
//     smallimage: "",
//     bigimage: "",
//     mainid: 1,
//     ismatch: false
//   }
// ];
// type MulitipleItem1 = {
//   id: number;
//   value: string;
//   value_hi: string;
//   checkvalue: string;
//   smallimage: string;
//   bigimage: string;
//   mainid: number;
//   ismatch: boolean; // <-- this is required
// };


// export const AllTasksProvider: React.FC<{ children: ReactNode, currentLang: any }> = ({ children, currentLang: initialLang }) => {
//   const [instructions33, setInstructions] = useState<InstructionItem[]>([
//     { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" }
//   ]);
//   const [instructions33default, setInstructionsdefault] = useState<InstructionItem[]>([
//     { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" }
//   ]);
//   // VisibilityContext state

//   // const [uploadedImages, setUploadedImages] = useState<{
//   //   [key: number]: { imageUrl: string; step: number };
//   // }>({})
//   const [combinedMultiplesState, setCombinedMultiplesState] = useState<MulitipleItem1[]>(defaultCombinedMultiples);
//   const [files, setFiles] = useState<{ id: number; file: File; preview: string }[]>([]);
//   const [files2, setFiles2] = useState<FileItem22[]>([]);
//   // const [files2, setFiles2] = useState<{ id: number; file: File; preview: string }[]>([]);
//   const [files3, setFiles3] = useState<{ id: number; file: File; preview: string }[]>([]);
//   const [files4, setFiles4] = useState<
//     { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[]
//   >([]);
//   // const [files4, setFiles4] = useState<{ id: number; file: File; preview: string; imageUrl: string }[]>([]);

//   const { id } = useParams();
//   const [step1data, setstep1data] = useState<any[]>([]);
//     const [alldefaultvalues, setdefaultvalues] = useState<any[]>([]);
//   const [currentlength, setcurrentlength] = useState(0);
//   const [step1data2, setstep1data2] = useState<any[]>([]);
//    const [step1data2default, setstep1data2default] = useState<any[]>([]);
   
//       const [step1data2defaultchekbox, setstep1data2defaultchekbox] = useState<any[]>([]);
//   const [allinone, setallinone] = useState<any[]>([]);
//     const [allhintsteps, setallhitssteps] = useState<any[]>([]);
//   const [uploadedImages, setUploadedImages] = useState<{ [key: number]: string }>({});

//   const [stepOneMultiples, setStepOneMultiples] = useState<MulitipleItemdd[]>([]);
//   const [transfer22, settransfer22] = useState<any>(null);
//   const [showImageUploadBanner, setShowImageUploadBanner] = useState(false);
//   const [test22, settest22] = useState("");
//   const [longDescriptions, setLongDescriptions] = useState<{ [key: string]: string }>({});
//   const [longDescriptionsHi, setLongDescriptionsHi] = useState<{ [key: string]: string }>({});

//   const [checkboxItems, setCheckboxItems] = useState<{ [key: number]: CheckboxItem[] }>({}); // Updated type

//   const [selectedItems, setSelectedItems] = useState<
//     { id: number; value: string; idid: number }[]
//   >([]);
//  const [selectedOption1, setSelectedOption1] = useState<string>("");
//   const [selectedmcq, setSelectedmcq] = useState('');
//   // const [selectedmcq22, setSelectedmcq22] = useState<{ [key: number]: string }>({});
// const [selectedmcq22, setSelectedmcq22] = useState<Record<number, string>>({});
//     // const [defaultipostermages, setdefaultipostermages] = useState('');
//     const [defaultipostermages, setdefaultipostermages] = useState<string[]>([]); // Fixed initialization
//         const [defaulttaskiconimages, setdefaulttaskiconimages] = useState<string[]>([]); // Fixed initialization

//   const [imagesdata, setimagesdata] = useState<{ id: number; images: string[] }[]>([]);
//   const [imagesdata3, setimagesdata3] = useState<{ id: number; images: string[] }[]>([]);
//   const [imagesdata1, setimagesdata1] = useState<{ id: number; images: string[] }[]>([]);
//   const [activeStep, setActiveStep] = useState<number>(1);
//   const [finalll, setfinalll] = useState<string[]>([]);  // const { sectionsData22, setSectionsData22 } = useTaskContext();

//   // availability state
//   const [instructionImageMap, setInstructionImageMap] = useState<
//     { mainId: number; instructionId: number; image: string }[]
//   >([]);


//   const [test22Value, setTest22Value] = useState<Record<number, string>>({});


//   const [textValueData, setTextValueData] = useState<{ id: number; value: string }[]>([]);

//   const [textValueData44, setTextValueData44] = useState<{ id: number; value: string }[]>([]);


//   const [textValueDatadefault, setTextValueDatadefault] = useState<{ id: number; value: string }[]>([]);
  
//     const [textValueDatadefaulthindi, setTextValueDatadefaulthindi] = useState<{ id: number; value: string }[]>([]);

//   const [textValueHiData, setTextValueHiData] = useState<{ id: number; value: string }[]>([]);

//   const [valueArray, setValueArray] = useState<{ mainid: number; index: number; value: string }[]>([]);
//   const [valueHiArray, setValueHiArray] = useState<{ mainid: number; index: number; value: string }[]>([]);


//   const [Tabname, setTabname] = useState("");
//   const [fileName, setfileName] = useState("");
//   const [finalvalue, setfinalvalue] = useState("");
//   const [showNoTask, setShowNoTask] = useState(false);
//   const [correctHintArray, setCorrectHintArray] = useState<{ id: number; index: number; value: string }[]>([]);
//   const [correctHintHiArray, setCorrectHintHiArray] = useState<{ id: number; index: number; value: string }[]>([]);

//   const [educationalData, seteducationalData] = useState<SectionData[]>([]);
//   const [sectionsData, setSectionsData] = useState<SectionData[]>([]);
//   const [currentLang, setCurrentLang] = useState<any>("en");
//   console.log(currentLang, "currentLangcurrentLang")
//   const [currentData, setCurrentData] = useMemo(() => {
//     return (
//       Tabname === "Educational task" ||
//       Tabname === "शैक्षिक कार्य" ||
//       Tabname === "शैक्षणिक कार्य" ||
//       Tabname === "Survey Task" ||
//       Tabname === "सर्वेक्षण" ||
//       Tabname === "Feedback Task" ||
//       Tabname === "प्रतिक्रिया" ||
//       Tabname=== "Image Capture Task" ||
//       Tabname=== "छवि कैप्चर कार्य" ||
//       Tabname === "Dotcode Scanning Task" ||
//       Tabname === "डॉटकोड स्कैनिंग कार्य"

//     )
//       ? [educationalData, seteducationalData]
//       : [sectionsData, setSectionsData];
//   }, [Tabname, educationalData, sectionsData]);

//   console.log(sectionsData, "55555555888888****")
//   console.log(currentData, "currentDatacccc", Tabname, "mmmmmmmmmmmmmmmmm")
//   console.log(combinedMultiplesState, "combinedMultiplesStatecombinedMultiplesState")
// console.log(selectedmcq22, "selectedmcq22788888556666666")
//   const [multiples99, setMultiples2299] = useState<any[]>([]); // or type it if you have a type
//   const [multiples888, setMultiples888] = useState<any[]>([]);
//   const [multiplesStep66, setMultiplesStep66] = useState<any[]>([]);
//   const [multiplesStep77, setMultiplesStep77] = useState<any[]>([]);
//   console.log(multiples99, "5577777777777777777777")
//   // useEffect(() => {
//   //   if (activeStep === 1 && multiples99.length === 0) {
//   //     const baseMultiples = [
//   //       { id: 1, value: "", checkvalue: "A", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
//   //       { id: 2, value: "", checkvalue: "B", value_hi: "", smallimage: "", bigimage: "" },
//   //       { id: 3, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
//   //       { id: 4, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
//   //       { id: 5, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
//   //     ];

//   //     const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
//   //     const combined = [
//   //       ...baseMultiples,
//   //       ...previousMultiples.map((m, index) => ({
//   //         ...m,
//   //         id: baseMultiples.length + index + 1, // ensure unique ID
//   //       })),
//   //     ];

//   //     setMultiples2299(combined);
//   //   }
//   // }, [sectionsData, activeStep]);

//   // useEffect(() => {
//   //   if (activeStep === 2 && multiples888.length === 0) {
//   //     const baseMultiples = [
//   //       { id: 1, value: "", checkvalue: "X", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
//   //       { id: 2, value: "", checkvalue: "Y", value_hi: "", smallimage: "", bigimage: "" },
//   //       { id: 3, value: "", checkvalue: "Z", value_hi: "", smallimage: "", bigimage: "" },
//   //     ];

//   //     const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
//   //     const combined = [
//   //       ...baseMultiples,
//   //       ...previousMultiples.map((m, index) => ({
//   //         ...m,
//   //         id: baseMultiples.length + index + 1,
//   //       })),
//   //     ];

//   //     setMultiples888(combined);
//   //   }
//   // }, [sectionsData, activeStep]);


//   console.log(multiples99,)
//   function buildQuestion(id: number, isMultipleChoice: boolean, instructions: InstructionItem[]): SectionData {
//     return {
//       id,
//       initialName: `Question ${id}`,
//       placeholder: "Your name",
//       markerImage: marker,
//       typographyText: "Page 1",
//       textValue: "",
//       textValue_hi: "",
//       language: currentLang,
//       iconimage: "",
//       smallquestionsimage: [],
//       mainplaceholder: "Write your question here",

//       selectValue: selectedmcq || (isMultipleChoice ? "multiplechoice" : ""),
//       optionsslectedvalue: null,
//       finalcorr: "",
//       correcthint: "",
//       correcthint_hi: "",
//       idid1: 0,
//       taskimage: "",
//       test245: "",
//       taskinstructions: [{ id: 1, value: "", image: "" }],
//       dropdownOptions: isMultipleChoice
//         ? [{ id: 2, label: "Single Answer Selection", value: "multiplechoice" }]
//         : [
//           { id: 2, label: "Single Answer Selection", value: "" },
//           { id: 3, label: "Multiple Answer Selection", value: "checkbox" },
//           // { id: 4, label: "Ratings Scale", value: "ratings" },
//           { id: 5, label: "MCQ Image", value: "mcqimage" },
//           { id: 6, label: "Long / Short Description", value: "longshortdescription" },
//         ],
//       instructions: instructions.map(dd => ({
//         id: dd.id,
//         value: "",
//         value_hi: "",
//         smallimage: "",
//         bigimage: "",
//       })),
//       Multiples: [
//         { id: 1, value: "", value_hi: "", checkvalue: "A", smallimage: "", bigimage: "" },
//         { id: 2, value: "", value_hi: "", checkvalue: "B", smallimage: "", bigimage: "" },
//         { id: 3, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
//         { id: 4, value: "", value_hi: "", checkvalue: "D", smallimage: "", bigimage: "" },
//         { id: 5, value: "", value_hi: "", checkvalue: "E", smallimage: "", bigimage: "" },
//       ],
//       Checkboxes: [
//         { id: 1, value: "", checked: false },
//         { id: 2, value: "", checked: false },
//         { id: 3, value: "", checked: false },
//       ],
//       rating: { initialStars: 0, maxStarsOptions: [5, 6, 7, 8, 9, 10] },
//     };
//   }

//   useEffect(() => {
//     if (currentlength > 0 && !id) {
//       setCurrentData(
//         Array.from({ length: currentlength }).map((_, index) =>
//           buildQuestion(index + 1, false, [])
//         )
//       );
//     }
//   }, [currentlength, id, currentLang, selectedmcq]); // Add selectedmcq as dependency
//   // -------------------- DERIVE engLang BASED ON DATA --------------------
//   // -------------------- DERIVE engLang BASED ON DATA + currentlength --------------------
//   const engLang: SectionData[] = useMemo(() => {
//     if (sectionsData.length > 0) {
//       return sectionsData.map((item, index) =>
//         buildQuestion(index + 1, item.selectValue === "multiplechoice", item.instructions || [])
//       );
//     } else if (educationalData.length > 0) {
//       return educationalData.map((item, index) =>
//         buildQuestion(index + 1, item.selectValue === "multiplechoice", item.instructions || [])
//       );
//     } else if (currentlength > 0) {
//       // Use currentlength to create that many default questions
//       return Array.from({ length: currentlength }).map((_, index) =>
//         buildQuestion(index + 1, false, [])
//       );
//     } else {
//       // Default single question
//       return [buildQuestion(1, false, [])];
//     }
//   }, [sectionsData, educationalData, currentLang, currentlength]);

//   useEffect(() => {
//     if (currentlength > 0 && !id) {
//       setCurrentData(Array.from({ length: currentlength }).map((_, index) =>
//         buildQuestion(index + 1, false, [])
//       ));
//     }
//   }, [currentlength, id, currentLang]);



//   console.log(engLang, "engLangengLangengLangengLang")
//   console.log(currentlength, "currentlengthcurrentlengthcurrentlength")

//   // if (currentlength > 0) {
//   //   engLang = Array.from({ length: currentlength }).map((_, index) => {
//   //     const isMultipleChoice = false;
//   //     return buildQuestion(index + 1, isMultipleChoice, []);
//   //   });
//   // }


//   console.log(currentlength, "currentlengthwww")
//   console.log(currentData, "checkcheckcheckcheckddddddddd")
//   const hindiLang = currentData.map((item) => {
//     const isMultipleChoice = item.selectValue === "multiplechoice";
//     console.log(engLang, "55555engLangengLang")
//     return {
//       id: item.id,
//       initialName: `प्रश्न ${item.id}`,
//       placeholder: "आपका नाम",
//       markerImage: marker,
//       typographyText: "पृष्ठ 1",
//       textValue: "ccccccccc",
//       language: "hi",
//       textValue_hi: "",
//       mainplaceholder: "अपना प्रश्न यहाँ लिखें",
//       selectValue: item.selectValue || "",
//       optionsslectedvalue: "",
//       finalcorr: "",
//       correcthint: "",
//       correcthint_hi: "",
//       smallquestionsimage: [],
//       idid1: 0,
//       taskimage: "",
//       iconimage: "",
//       test245: "",
//       taskinstructions: Array.from({ length: currentData.find(cd => cd.id === item.id)?.taskinstructions.length || 1 }, (_, i) => ({
//         id: i + 1,
//         value: "",
//         image: ""
//       })),

//       dropdownOptions: isMultipleChoice
//         ? [{ id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" }]
//         : [
//           // { id: 1, label: "चित्र लें", value: "" },
//           { id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" },
//           { id: 3, label: "एकाधिक उत्तर चयन", value: "" },
//           { id: 4, label: "रेटिंग स्केल", value: "raatings" },
//           { id: 5, label: "एमसीक्यू छवि", value: "mcqimage" },
//           { id: 5, label: "लंबा / संक्षिप्त विवरण", value: "longshortdescription" },
//         ],
//       // instructions: [
//       //   { id: 1, value: "",value_hi:"", smallimage: "", bigimage: "" },
//       // ],
//       instructions: Array.from(
//         { length: currentData.find(cd => cd.id === item.id)?.instructions.length || 1 },
//         (_, i) => ({
//           id: i + 1,
//           value: "",
//           value_hi: "",
//           smallimage: "",
//           bigimage: ""
//         })
//       ),
//       Multiples: [
//         { id: 1, value: "", value_hi: "", checkvalue: "A", smallimage: "", bigimage: "" },
//         { id: 2, value: "", value_hi: "", checkvalue: "B", smallimage: "", bigimage: "" },
//         { id: 3, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
//         { id: 4, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
//         { id: 5, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
//       ],
//       Checkboxes: [
//         { id: 1, value: "", checked: false },
//         { id: 2, value: "", checked: false },
//         { id: 3, value: "", checked: false },
//       ],
//       rating: {
//         initialStars: 0,
//         maxStarsOptions: [5, 6, 7, 8, 9, 10],
//       },
//     };
//   });


//   // hindiLang.forEach((item) => {
//   //   item.dropdownOptions =
//   //     item.selectValue === "multiplechoice"
//   //       ? [
//   //           { id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" },
//   //         ]
//   //       : [
//   //           { id: 1, label: "चित्र लें", value: "" },
//   //           { id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" },
//   //           { id: 3, label: "एकाधिक उत्तर चयन", value: "checkbox" },
//   //           { id: 4, label: "रेटिंग स्केल", value: "ratings" },
//   //         ];
//   // });

//   const maritiLang = [
//     {
//       id: 1,
//       initialName: currentLang,
//       placeholder: "तुमचे नाव",
//       markerImage: marker,
//       typographyText: "पृष्ठ 1",
//       textValue: "",
//       textValue_hi: "",
//       mainplaceholder: "इथे तुमचा प्रश्न लिहा",
//       selectValue: "",
//       iconimage: "",
//       smallquestionsimage: [],
//       optionsslectedvalue: "",
//       finalcorr: "",
//       correcthint: "",
//       correcthint_hi: "",
//       idid1: 0,
//       taskimage: "",
//       test245: "",
//       taskinstructions: [{ id: 1, value: "", image: "" }], dropdownOptions: [
//         { id: 1, label: "चित्र काढा", value: "" },
//         { id: 2, label: "एकच उत्तर निवडा", value: "multiplechoice" },
//         { id: 3, label: "अनेक उत्तरे निवडा", value: "checkbox" },
//         { id: 4, label: "रेटिंग स्केल", value: "ratings" },
//         { id: 5, label: "रेटिंग स्केल", value: "mcqimage" },
//         { id: 6, label: "लंबा / संक्षिप्त विवरण", value: "longshortdescription" },
//       ],
//       instructions: [
//         { id: 1, value: "", smallimage: "", bigimage: "" },
//       ],
//       Multiples: [
//         { id: 1, value: "", checkvalue: "अ", smallimage: "", bigimage: "" },
//         { id: 2, value: "", checkvalue: "ब", smallimage: "", bigimage: "" },
//         { id: 3, value: "", checkvalue: "क", smallimage: "", bigimage: "" },
//         { id: 4, value: "", checkvalue: "ड", smallimage: "", bigimage: "" },
//         { id: 5, value: "", checkvalue: "इ", smallimage: "", bigimage: "" },
//       ],
//       Checkboxes: [
//         { id: 1, value: "", checked: false },
//         { id: 2, value: "", checked: false },
//         { id: 3, value: "", checked: false },
//       ],
//       rating: {
//         initialStars: 0,
//         maxStarsOptions: [5, 6, 7, 8, 9, 10],
//       },
//     },
//     {
//       id: 2,
//       initialName: "प्रश्न 2",
//       placeholder: "तुमचे नाव",
//       markerImage: marker,
//       typographyText: "पृष्ठ 2",
//       textValue: "",
//       textValue_hi: "",
//       taskimage: "", iconimage: "",
//       smallquestionsimage: [],
//       mainplaceholder: "इथे तुमचा प्रश्न लिहा",
//       selectValue: "",
//       optionsslectedvalue: "",
//       finalcorr: "",
//       correcthint: "",
//       correcthint_hi: "",
//       idid1: 0,

//       test245: "",
//       taskinstructions: [{ id: 1, value: "", image: "" }],
//       dropdownOptions: [
//         { id: 1, label: "चित्र काढा", value: "" },
//         { id: 2, label: "एकच उत्तर निवडा", value: "multiplechoice" },
//         { id: 3, label: "अनेक उत्तरे निवडा", value: "checkbox" },
//         { id: 4, label: "रेटिंग स्केल", value: "ratings" },
//         { id: 5, label: "रेटिंग स्केल", value: "mcqimage" },
//         { id: 6, label: "लंबा / संक्षिप्त विवरण", value: "longshortdescription" },
//       ],
//       instructions: [
//         { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" },
//       ],
//       Multiples: [
//         { id: 1, value: "", checkvalue: "अ", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//         { id: 2, value: "", checkvalue: "ब", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//         { id: 3, value: "", checkvalue: "क", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//         { id: 4, value: "", checkvalue: "ड", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//         { id: 5, value: "", checkvalue: "इ", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//       ],
//       Checkboxes: [
//         { id: 1, value: "", checked: false },
//         { id: 2, value: "", checked: false },
//         { id: 3, value: "", checked: false },
//       ],
//       rating: {
//         initialStars: 0,
//         maxStarsOptions: [5, 6, 7, 8, 9, 10],
//       },
//     },
//   ];
//   //End  Availablity, Education


//   //   useEffect(() => {
//   //     const getLanguageData = () => {
//   //       switch (currentLang) {
//   //         case "en":
//   //           return engLang;
//   //         case "mr":
//   //           return maritiLang;
//   //         case "hi":
//   //           return hindiLang;
//   //         default:
//   //           return engLang;
//   //       }
//   //     };
//   //     setSectionsData(getLanguageData() as SectionData[]);
//   // seteducationalData(getLanguageData() as SectionData[]);
//   // settargetData(getLanguageData() as SectionData[]);

//   //   }, [currentLang]);


//   const prevLangRef = useRef<string>();

//   useEffect(() => {
//     // Skip if language hasn't changed
//     if (prevLangRef.current === currentLang) return;

//     const getLanguageData = () => {
//       switch (currentLang) {
//         case "en": return engLang;
//         case "mr": return maritiLang;
//         case "hi": return hindiLang;
//         default: return engLang;
//       }
//     };

//     const langData = getLanguageData();
//     setSectionsData(langData as SectionData[]);
//     seteducationalData(langData as SectionData[]);
//     settargetData(langData as SectionData[]);

//     // Update ref with current language
//     prevLangRef.current = currentLang;
//   }, [currentLang]);



//   // const [sectionsData, setSectionsData] = useState<SectionData[]>(finalLang);

//   // educations task
//   console.log(sectionsData, currentLang, "xxxxxxxxxxxxxx")
//   // const [educationalData, seteducationalData] = useState<SectionData[]>([]);
//   // target task
//   const [targetData, settargetData] = useState<SectionData[]>([]);

//   //   const [multiples99, setMultiples2299] = useState<any[]>([]); // or type it if you have a type
//   //   const [multiples888, setMultiples888] = useState<any[]>([]);
//   //   const [multiplesStep66, setMultiplesStep66] = useState<any[]>([]);
//   // const [multiplesStep77, setMultiplesStep77] = useState<any[]>([]);
//   // console.log(multiples99, "5577777777777777777777")
//   //   useEffect(() => {

//   //     if (activeStep === 1) {
//   //       const baseMultiples = [
//   //         { id: 1, value: "", checkvalue: "A", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
//   //         { id: 2, value: "", checkvalue: "B", value_hi: "", smallimage: "", bigimage: "" },
//   //         { id: 3, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
//   //         { id: 4, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
//   //         { id: 5, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
//   //       ];

//   //       const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
//   //       const combined = [
//   //         ...baseMultiples,
//   //         ...previousMultiples.map((m, index) => ({
//   //           ...m,
//   //           id: baseMultiples.length + index + 1, // ensure unique ID
//   //         })),
//   //       ];

//   //       setMultiples2299(combined);
//   //     }
//   //   }, [sectionsData, activeStep]);
//   //   useEffect(() => {
//   //     if (activeStep === 2) {
//   //       const baseMultiples = [
//   //         { id: 1, value: "", checkvalue: "X", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
//   //         { id: 2, value: "", checkvalue: "Y", value_hi: "", smallimage: "", bigimage: "" },
//   //         { id: 3, value: "", checkvalue: "Z", value_hi: "", smallimage: "", bigimage: "" },
//   //       ];

//   //       const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
//   //       const combined = [
//   //         ...baseMultiples,
//   //         ...previousMultiples.map((m, index) => ({
//   //           ...m,
//   //           id: baseMultiples.length + index + 1,
//   //         })),
//   //       ];

//   //       setMultiples888(combined);
//   //     }
//   //   }, [sectionsData, activeStep]);


//   console.log(multiples99, "oooo4444%%%%%%%sssss%%%%%")

//   let uyu = []

// //   const getDropdownOptions = (selectedType: string | undefined) => {
// //   const getLocalizedText = (text: { en: string; hi: string; mr: string }) => {
// //     return currentLang === "hi" ? text.hi : currentLang === "mr" ? text.mr : text.en;
// //   };
// //   console.log(selectedType, "selectedTypessssssssswww")

// //   // Default to single answer selection if selectedType is empty/undefined
// //   if (!selectedType) {
// //     return [
// //       {
// //         id: 2,
// //         label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
// //         value: "",
// //       },
  
// //         {
// //           id: 3,
// //           label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
// //           value: "checkbox",
// //         },
// //         {
// //           id: 5,
// //           label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
// //           value: "mcqimage",
// //         },
// //         {
// //           id: 6,
// //           label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
// //           value: "longshortdescription",
// //         },
// //     ];
// //   }

// //   return selectedType === "multiplechoice"
// //     ? [
// //         {
// //           id: 2,
// //           label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
// //           value: "multiplechoice",
// //         },
// //         {
// //           id: 3,
// //           label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
// //           value: "checkbox",
// //         },
// //         {
// //           id: 5,
// //           label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
// //           value: "mcqimage",
// //         },
// //         {
// //           id: 6,
// //           label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
// //           value: "longshortdescription",
// //         },
// //       ]
// //     : [
// //         {
// //           id: 2,
// //           label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
// //           value: "multiplechoice",
// //         },
// //         {
// //           id: 3,
// //           label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
// //           value: "checkbox",
// //         },
// //         {
// //           id: 5,
// //           label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
// //           value: "mcqimage",
// //         },
// //         {
// //           id: 6,
// //           label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
// //           value: "longshortdescription",
// //         },
// //       ];
// // };

// const getDropdownOptions = (selectedType: string | undefined) => {
//   const getLocalizedText = (text: { en: string; hi: string; mr: string }) => {
//     return currentLang === "hi" ? text.hi : currentLang === "mr" ? text.mr : text.en;
//   };

//   console.log(selectedType, "selectedTypessssssssswww");

//   // Define the dropdown options
//   const dropdownOptions = [
//     {
//       id: 2,
//       label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
//       value: "", // Always empty for Single Answer Selection
//     },
//     {
//       id: 3,
//       label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
//       value: "checkbox",
//     },
//     {
//       id: 5,
//       label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
//       value: "mcqimage",
//     },
//     {
//       id: 6,
//       label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
//       value: "longshortdescription",
//     },
//   ];

//   // If selectedType is "multiplechoice", filter to only show Single Answer Selection
//   return selectedType === "multiplechoice"
//     ? [
//         {
//           id: 2,
//           label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
//           value: "", // Ensure it remains empty
//         },
//       ]
//     : dropdownOptions; // Return all options for other cases
// };
// useEffect(() => {
//   setCurrentData(prev =>
//     prev.map(question => {
//       const selectedType = selectedmcq22[question.id];

//       // If empty string or undefined, use empty string
//       const type = !selectedType || selectedType.trim() === "" 
//         ? "" 
//         : selectedType;
// console.log(selectedType, "selectedType78888",type, "typetypetypetypetypetype")
//       return {
//         ...question,
//         selectValue: type,
//         dropdownOptions: getDropdownOptions(type),
//       };
//     })
//   );
// }, [selectedmcq22, currentLang]);

// console.log(currentData, "currentDataseeeeeeeeeee")

//  const addQuestionss = (tabName: string) => {
//   console.log(tabName, "888888888888888888888");
//   const getLocalizedText = (text: { en: string; hi: string; mr: string }) => {
//     return currentLang === "hi" ? text.hi : currentLang === "mr" ? text.mr : text.en;
//   };

//   const latestItem = currentData[currentData.length - 1];
//   const currentMultiples = latestItem?.Multiples || [];
//   console.log(currentMultiples, "currentMultiples (latest only)");

//   // Update sectionsData with combinedMultiples
//   const combinedMultiples = currentMultiples;
//   console.log(combinedMultiples, "combinedMultiples444444444444");

//   setSectionsData(prev =>
//     prev.map((section, index) =>
//       index === prev.length - 1
//         ? { ...section, Multiples: combinedMultiples }
//         : section
//     )
//   );

//   // Determine the selectValue based on selectedmcq22
//   const newQuestionId = sectionsData.length + 1;
//   const selectedType = selectedmcq22[newQuestionId] || ""; // Get the selected type from selectedmcq22, default to ""

//   const availablityQuestion: SectionData = {
//     id: newQuestionId,
//     initialName: getLocalizedText({
//       en: `Question ${newQuestionId}`,
//       hi: `प्रश्न ${newQuestionId}`,
//       mr: `प्रश्न ${newQuestionId}`,
//     }),
//     placeholder: getLocalizedText({ en: "Your name", hi: "आपका नाम", mr: "तुमचे नाव" }),
//     markerImage: marker,
//     typographyText: `Page ${newQuestionId}`,
//     textValue: "",
//     textValue_hi: "",
//     iconimage: "",
//     mainplaceholder: getLocalizedText({
//       en: "Write your question here",
//       hi: "अपना प्रश्न यहाँ लिखें",
//       mr: "आपला प्रश्न येथे लिहा",
//     }),
//     selectValue: selectedType, // Set based on selectedmcq22
//     smallquestionsimage: [],
//     optionsslectedvalue: "",
//     finalcorr: "",
//     correcthint: "",
//     correcthint_hi: "",
//     idid1: 0,
//     taskimage: "",
//     test245: "",
//     taskinstructions: [{ id: 1, value: "", image: "" }],
//     dropdownOptions: selectedType === "multiplechoice"
//       ? [
//           {
//             id: 2,
//             label: getLocalizedText({
//               en: "Single Answer Selection",
//               hi: "एकल उत्तर चयन",
//               mr: "एकल उत्तर निवड",
//             }),
//             value: "multiplechoice",
//           },
//         ]
//       : [
//           {
//             id: 2,
//             label: getLocalizedText({
//               en: "Single Answer Selection",
//               hi: "एकल उत्तर चयन",
//               mr: "एकल उत्तर निवड",
//             }),
//             value: "multiplechoice",
//           },
//           {
//             id: 3,
//             label: getLocalizedText({
//               en: "Multiple Answer Selection",
//               hi: "एकाधिक उत्तर चयन",
//               mr: "अनेक उत्तरे निवड",
//             }),
//             value: "checkbox",
//           },
//           {
//             id: 5,
//             label: getLocalizedText({
//               en: "MCQ Image",
//               hi: "एमसीक्यू छवि",
//               mr: "एमसीक्यू प्रतिमा",
//             }),
//             value: "mcqimage",
//           },
//           {
//             id: 6,
//             label: getLocalizedText({
//               en: "Long / Short Description",
//               hi: "लंबा / संक्षिप्त विवरण",
//               mr: "लांब / संक्षिप्त वर्णन",
//             }),
//             value: "longshortdescription",
//           },
//         ],
//     instructions: [
//       { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" },
//     ],
//     Multiples: combinedMultiples,
//     Checkboxes: [
//       { id: 1, value: "", checked: false },
//       { id: 2, value: "", checked: false },
//       { id: 3, value: "", checked: false },
//     ],
//     rating: {
//       initialStars: 0,
//       maxStarsOptions: [5, 6, 7, 8, 9, 10],
//     },
//     language: "",
//   };

//   console.log(availablityQuestion, "availablityQuestion433333");

//   // Similarly for educationQuestion
//   const educationQuestion: SectionData = {
//     id: educationalData.length + 1,
//     initialName: getLocalizedText({
//       en: `Question ${educationalData.length + 1}`,
//       hi: `प्रश्न ${educationalData.length + 1}`,
//       mr: `प्रश्न ${educationalData.length + 1}`,
//     }),
//     placeholder: getLocalizedText({ en: "Your name", hi: "आपका नाम", mr: "तुमचे नाव" }),
//     markerImage: marker,
//     typographyText: `Page ${educationalData.length + 1}`,
//     textValue: "",
//     textValue_hi: "",
//     iconimage: "",
//     mainplaceholder: getLocalizedText({
//       en: "Write your question here",
//       hi: "अपना प्रश्न यहाँ लिखें",
//       mr: "आपला प्रश्न येथे लिहा",
//     }),
//     selectValue: selectedType, // Set based on selectedmcq22
//     smallquestionsimage: [],
//     optionsslectedvalue: "",
//     finalcorr: "",
//     correcthint: "",
//     correcthint_hi: "",
//     idid1: 0,
//     taskimage: "",
//     test245: "",
//     taskinstructions: [{ id: 1, value: "", image: "" }],
//     dropdownOptions: selectedType === "multiplechoice"
//       ? [
//           {
//             id: 2,
//             label: getLocalizedText({
//               en: "Single Answer Selection",
//               hi: "एकल उत्तर चयन",
//               mr: "एकल उत्तर निवड",
//             }),
//             value: "multiplechoice",
//           },
//         ]
//       : [
//           {
//             id: 2,
//             label: getLocalizedText({
//               en: "Single Answer Selection",
//               hi: "एकल उत्तर चयन",
//               mr: "एकल उत्तर निवड",
//             }),
//             value: "multiplechoice",
//           },
//           {
//             id: 3,
//             label: getLocalizedText({
//               en: "Multiple Answer Selection",
//               hi: "एकाधिक उत्तर चयन",
//               mr: "अनेक उत्तरे निवड",
//             }),
//             value: "checkbox",
//           },
//           {
//             id: 5,
//             label: getLocalizedText({
//               en: "MCQ Image",
//               hi: "एमसीक्यू छवि",
//               mr: "एमसीक्यू प्रतिमा",
//             }),
//             value: "mcqimage",
//           },
//           {
//             id: 6,
//             label: getLocalizedText({
//               en: "Long / Short Description",
//               hi: "लंबा / संक्षिप्त विवरण",
//               mr: "लांब / संक्षिप्त वर्णन",
//             }),
//             value: "longshortdescription",
//           },
//         ],
//     instructions: [
//       { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" },
//     ],
//     Multiples: [
//       { id: 1, value: "", checkvalue: "A", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//       { id: 2, value: "", checkvalue: "B", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//       { id: 3, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//       { id: 4, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//       { id: 5, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
//     ],
//     Checkboxes: [
//       { id: 1, value: "", checked: false },
//       { id: 2, value: "", checked: false },
//       { id: 3, value: "", checked: false },
//     ],
//     rating: {
//       initialStars: 0,
//       maxStarsOptions: [5, 6, 7, 8, 9, 10],
//     },
//     language: "",
//   };

//   // Update the appropriate data based on tabName
//   if (
//     tabName === "Educational task" ||
//     tabName === "शैक्षिक कार्य" ||
//     tabName === "शैक्षणिक कार्य"
//   ) {
//     seteducationalData(prev => [...prev, educationQuestion]);
//   } else {
//     setSectionsData(prev => [...prev, availablityQuestion]);
//   }
// };
//   // const [currentData, setCurrentData] = useMemo(() => {
//   //   return (
//   //     Tabname === "Educational task" ||
//   //     Tabname === "शैक्षिक कार्य" ||
//   //     Tabname === "शैक्षणिक कार्य"
//   //   )
//   //     ? [educationalData, seteducationalData]
//   //     : [sectionsData, setSectionsData];
//   // }, [Tabname, sectionsData, setSectionsData, educationalData, seteducationalData]);
//   console.log(multiples99, "multiples99sssssssss")
//   console.log(currentData, "sectionsDatasectionsDatasectionsData");
//   const filteredSections = sectionsData.filter(item => item.textValue !== "" && item.textValue !== null);
//   console.log(filteredSections, "Filtered sectionsData");
//   const [state, setState] = useState<TaskState>({
//     instructions: [{ id: 1, value: "", image: "" }],
//     idid: 0,
//     textname: "",
//     multiples: [{ id: 0, value: "", checkvalue: "", smallimage: "", bigimage: "", ismatch: false }], // Ensure the correct type
//     selectedValue: "",
//     text: "",
//     sectionsData: 0
//   });

//   return (
//     <TaskContext.Provider
//       value={{
//         //Notes show
//         step1data2defaultchekbox, setstep1data2defaultchekbox,
//         step1data, setstep1data,
//         step1data2, setstep1data2,
//         step1data2default, setstep1data2default,
//         setdefaultvalues,alldefaultvalues,
//         combinedMultiplesState, setCombinedMultiplesState,
//         files, setFiles,
//         longDescriptionsHi, setLongDescriptionsHi,
//         files2, setFiles2,
//         files3, setFiles3,
//         files4, setFiles4,
//         multiples888, setMultiples888, multiples99, setMultiples2299,
//         transfer22, settransfer22,
//         uploadedImages, setUploadedImages,
//         stepOneMultiples,
//         setStepOneMultiples,
//         setcurrentlength, currentlength,
//         test22Value, setTest22Value,
//         longDescriptions, setLongDescriptions,
//         selectedmcq, setSelectedmcq,
        
//         defaultipostermages, setdefaultipostermages,
//         defaulttaskiconimages, setdefaulttaskiconimages,
//         selectedOption1,setSelectedOption1,
//         valueArray, setValueArray,
//         valueHiArray, setValueHiArray,
//         instructionImageMap,
//         setInstructionImageMap,
//         textValueData,
//         setTextValueData,
//         textValueDatadefault, setTextValueDatadefault,
//         textValueDatadefaulthindi, setTextValueDatadefaulthindi,
//         textValueData44,
//         setTextValueData44,
//         textValueHiData,
//         setTextValueHiData,
//         setCorrectHintArray,
//         setCorrectHintHiArray,
//         correctHintArray,
//         correctHintHiArray,
//         showNoTask,
//         activeStep,
//         setActiveStep,
//         setCurrentData,
//         currentData,
//         setfinalll,
//         setShowNoTask,
//         finalll,
//         setallinone, allinone,
//         allhintsteps, setallhitssteps,
//         test22, settest22,
//         state,
//         setState,
//         setfinalvalue,
//         finalvalue,
//         setInstructions,
//         instructions33,
//         instructions33default, setInstructionsdefault,
//         setTabname,
//         Tabname,
//         setfileName,
//         fileName,

//         //Notes show
//         // sectionsData22,
//         // setSectionsData22,
//         // availability questions data
//         sectionsData,
//         setSectionsData,
//         // availability questions data

//         // eduacational questions data
//         educationalData,
//         seteducationalData,
//         // eduacational questions data

//         // availability questions data
//         targetData,
//         settargetData,
//         // availability questions data
//         setimagesdata1,
//         imagesdata1,
//         setimagesdata3,
//         imagesdata3,
//         imagesdata,
//         setimagesdata,

//         // Questions show
//         addQuestionss,
//         showImageUploadBanner,
//         setShowImageUploadBanner,
//         // Questions show
//         currentLang,
//         setCurrentLang,
//         checkboxItems,
//         setCheckboxItems,
//         selectedItems, setSelectedItems,
//         selectedmcq22, setSelectedmcq22
//       }}
//     >
//       {children}
//     </TaskContext.Provider>
//   );
// };

// // Custom hooks
// export const useTaskContext = () => {
//   const context = useContext(TaskContext);
//   if (!context) {
//     throw new Error("useTaskContext must be used within an AppProvider");
//   }
//   return context;
// };



import React, { createContext, useContext, useState, ReactNode, useEffect, useMemo, useRef } from "react";
import marker from "../../../src/assests/images/marker_black.svg";
import { useParams } from "react-router-dom";

// Interfaces for TaskContext
interface SectionData {
  value?: string;
  id: number;
  initialName: string;
  placeholder: string;
  markerImage: string;
  typographyText: string;
  textValue: string;
  textValue_hi: string;
  language: string;
  iconimage: string;
  mainplaceholder: string;
  main_question_id: string; // <-- Added property

  selectValue: string;
  smallquestionsimage: string[];
  optionsslectedvalue: string | null;
  finalcorr?: string;
  correcthint: string;
  correcthint_hi: string;
  idid1: number;
  taskinstructions: { id: number; value: string; image: string }[];
  taskimage: string;
  test245: string;

  dropdownOptions: { id: number; label: string; value: string }[];
  instructions: { id: number; value: string; value_hi: string; smallimage: string; bigimage: string }[];
  Multiples: { id: number; value: string; value_hi: string; checkvalue: string; smallimage: string; bigimage: string; ismatch?: boolean }[];
  Checkboxes: { id: number; value: string; checked: boolean }[];
  rating: { initialStars: number; maxStarsOptions: number[] };
}
interface FileItem {
  id: number;
  file: File;
  preview: string;

}
type FileItem22 = {
  id: number;
  file?: File;       // optional now
  preview: string;
  imageUrl: string;
};
interface MultipleItem {
  id: number;
  value: string;
  value_hi: string;
  checkvalue: string;
  smallimage: string;
  bigimage: string;
  ismatch?: boolean;
}

interface CheckboxItem {
  main_question_id: any;
  id: number;
  value: string;
  value_hi: string; // Added value_hi field
  checked: boolean;
  idid: number;
  smallimage: string;
  bigimage: string;
}

interface FileItem1 {
  id: number;
  file: File;
  preview: string;
  imageUrl: string

}


interface MulitipleItem {
  id: number;
  value: string;
  checkvalue: string;
  smallimage: string, bigimage: string
  ismatch: false
}
type Item = { id: number; value: string; idid: number };
interface AllTasksProviderProps {
  children: React.ReactNode;
  currentLang: any; // Adjust type accordingly (string, object, etc.)
}
interface TaskState {
  instructions: { id: number; value: string; image: string }[];
  idid: number;
  textname: string;
  multiples: MulitipleItem[]; // Ensure the correct type
  selectedValue: string | null;
  text: string
  sectionsData: number
}
type InstructionImageMapType = {
  mainId: number;
  instructionId: number;
  image: string;
  hint_id: string;
  primarykeyid: number
};

interface TaskContextType {
  showNoTask: boolean;
  setShowNoTask: (value: boolean) => void;

  sectionsData: SectionData[];
  setSectionsData: React.Dispatch<React.SetStateAction<SectionData[]>>;
  Tabname: string;

  setTabname: (value: string) => void;
  setfinalvalue: (value: string) => void;

  setfileName: (value: string) => void;
  fileName: string
  finalvalue: string
  targetData: SectionData[];
  test22: string
  finalll: string[]
  correctHintArray: { id: number; index: number; value: string; hint_id: string }[];
  setCorrectHintArray: React.Dispatch<React.SetStateAction<{ id: number; index: number; value: string; hint_id: string }[]>>;
  correctHintHiArray: { id: number; index: number; value: string; hint_id: string }[];
  setCorrectHintHiArray: React.Dispatch<React.SetStateAction<{ id: number; index: number; value: string; hint_id: string }[]>>;

  textValueData: { id: number; value: string }[];
  setTextValueData: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;

  textValueDatadefault: { id: number; value: string }[];
  setTextValueDatadefault: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;

   textValueDatadefaulthindi: { id: number; value: string }[];
  setTextValueDatadefaulthindi: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;


  textValueData44: { id: number; value: string }[];
  setTextValueData44: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;


  textValueHiData: { id: number; value: string }[];
  setTextValueHiData: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;

  instructionImageMap: InstructionImageMapType[];
  setInstructionImageMap: React.Dispatch<
    React.SetStateAction<InstructionImageMapType[]>
  >;


  valueArray: { mainid: number; index: number; value: string,hint_id:string ,primarykeyid: number}[];
  setValueArray: React.Dispatch<React.SetStateAction<{ mainid: number; index: number; value: string,hint_id:string,primarykeyid: number }[]>>;
  valueHiArray: { mainid: number; index: number; value: string; hint_id: string; primarykeyid: number }[];
  setValueHiArray: React.Dispatch<React.SetStateAction<{ mainid: number; index: number; value: string; hint_id: string; primarykeyid: number }[]>>;

  setfinalll: (value: string[]) => void;
  settest22: (value: string) => void;
  settargetData: React.Dispatch<React.SetStateAction<SectionData[]>>;
  selectedmcq: string;
  setSelectedmcq: (value: string) => void;

  selectedmcq22: Record<number, string>;
  setSelectedmcq22: React.Dispatch<React.SetStateAction<Record<number, string>>>;

defaultipostermages: string[];
  setdefaultipostermages: React.Dispatch<React.SetStateAction<string[]>>;


  
defaulttaskiconimages: string[];
  setdefaulttaskiconimages: React.Dispatch<React.SetStateAction<string[]>>;



  
selectedOption1: string;
  setSelectedOption1: React.Dispatch<React.SetStateAction<string>>;
  educationalData: SectionData[];
  seteducationalData: React.Dispatch<React.SetStateAction<SectionData[]>>;
  state: TaskState;
  setState: React.Dispatch<React.SetStateAction<TaskState>>;
  addQuestionss: (tabName: any) => void;
  showImageUploadBanner: boolean;
  setShowImageUploadBanner: (value: boolean) => void;
  currentLang: string,



  checkboxItems: { [key: number]: CheckboxItem[] }; // Updated type
  setCheckboxItems: React.Dispatch<React.SetStateAction<{ [key: number]: CheckboxItem[] }>>; // Updated type
  setCurrentLang: (lang: string) => void;
  instructions33: InstructionItem[];
  instructions33default:InstructionItem[];
  imagesdata: { id: number; images: string[] }[];
  setimagesdata: React.Dispatch<React.SetStateAction<{ id: number; images: string[] }[]>>;
  imagesdata3: { id: number; images: string[] }[];
  setimagesdata3: React.Dispatch<React.SetStateAction<{ id: number; images: string[] }[]>>;
  imagesdata1: { id: number; images: string[] }[];
  setimagesdata1: React.Dispatch<React.SetStateAction<{ id: number; images: string[] }[]>>;
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  setInstructions: React.Dispatch<React.SetStateAction<InstructionItem[]>>;

  setInstructionsdefault: React.Dispatch<React.SetStateAction<InstructionItem[]>>;

  



  test22Value: Record<number, string>;
  setTest22Value: React.Dispatch<React.SetStateAction<Record<number, string>>>;
  stepOneMultiples: MulitipleItemdd[];
  setStepOneMultiples: React.Dispatch<React.SetStateAction<MulitipleItemdd[]>>;
  currentData: any;
  setCurrentData: React.Dispatch<React.SetStateAction<any>>;
  currentlength: number;
  setcurrentlength: React.Dispatch<React.SetStateAction<number>>;
  multiples888: any[];
  setMultiples888: React.Dispatch<React.SetStateAction<any[]>>;

  multiples99: any[];
  setMultiples2299: React.Dispatch<React.SetStateAction<any[]>>;

  combinedMultiplesState: typeof defaultCombinedMultiples;
  setCombinedMultiplesState: React.Dispatch<React.SetStateAction<typeof defaultCombinedMultiples>>;

  files: FileItem[];
  setFiles: React.Dispatch<React.SetStateAction<FileItem[]>>;
  longDescriptions: { [key: string]: string };
  setLongDescriptions: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;

  files3: FileItem[];
  setFiles3: React.Dispatch<React.SetStateAction<FileItem[]>>;


  selectedItems: Item[];
  setSelectedItems: React.Dispatch<React.SetStateAction<Item[]>>;


  files2: FileItem22[];
  setFiles2: React.Dispatch<React.SetStateAction<FileItem22[]>>;
  longDescriptionsHi: { [key: string]: string }; // New state for Hindi descriptions
  setLongDescriptionsHi: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;

  //    files4: FileItem1[];
  // setFiles4: React.Dispatch<React.SetStateAction<FileItem1[]>>;

  files4: { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[];
  setFiles4: React.Dispatch<
    React.SetStateAction<
      { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[]
    >
  >

  transfer22: any;
  settransfer22: React.Dispatch<React.SetStateAction<any>>;
  uploadedImages: { [key: number]: string };
  setUploadedImages: React.Dispatch<React.SetStateAction<{ [key: number]: string }>>;
  // sectionsData22: SectionData[];
  // setSectionsData22: React.Dispatch<React.SetStateAction<SectionData[]>>;

  step1data: any[];
  setstep1data: React.Dispatch<React.SetStateAction<any[]>>;

  alldefaultvalues: any[];
  setdefaultvalues: React.Dispatch<React.SetStateAction<any[]>>;


  step1data2: any[];
  setstep1data2: React.Dispatch<React.SetStateAction<any[]>>;


  

  step1data2default: any[];
  setstep1data2default: React.Dispatch<React.SetStateAction<any[]>>;


    step1data2defaultchekbox: any[];
  setstep1data2defaultchekbox: React.Dispatch<React.SetStateAction<any[]>>;

  allinone: any[], setallinone: React.Dispatch<React.SetStateAction<any[]>>;


    allhintsteps: any[], setallhitssteps: React.Dispatch<React.SetStateAction<any[]>>;


}

// Create Contexts
const TaskContext = createContext<TaskContextType | undefined>(undefined);
interface InstructionItem {
  media?: any;
  id: number;
  value: string;
  value_hi: string
  smallimage: string;
  bigimage: string
}

interface MulitipleItemdd {
  value_hi: unknown;
  id: number;
  value: string;
  checkvalue: string;
  smallimage: string
  bigimage: string
  mainid: number;
}

const defaultCombinedMultiples = [
  {
    id: 1,
    value: "",
    value_hi: "",
    checkvalue: "check1",
    smallimage: "",
    bigimage: "",
    mainid: 1,
    ismatch: false
  },
  {
    id: 2,
    value: "",
    value_hi: "",
    checkvalue: "check2",
    smallimage: "",
    bigimage: "",
    mainid: 1,
    ismatch: false
  },
  {
    id: 3,
    value: "",
    value_hi: "",
    checkvalue: "check3",
    smallimage: "",
    bigimage: "",
    mainid: 1,
    ismatch: false
  },
  {
    id: 4,
    value: "",
    value_hi: "",
    checkvalue: "check4",
    smallimage: "",
    bigimage: "",
    mainid: 1,
    ismatch: false
  }
];
type MulitipleItem1 = {
  id: number;
  value: string;
  value_hi: string;
  checkvalue: string;
  smallimage: string;
  bigimage: string;
  mainid: number;
  ismatch: boolean; // <-- this is required
};


export const AllTasksProvider: React.FC<{ children: ReactNode, currentLang: any }> = ({ children, currentLang: initialLang }) => {
  const [instructions33, setInstructions] = useState<InstructionItem[]>([
    { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" }
  ]);
  const [instructions33default, setInstructionsdefault] = useState<InstructionItem[]>([
    { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" }
  ]);
  // VisibilityContext state

  // const [uploadedImages, setUploadedImages] = useState<{
  //   [key: number]: { imageUrl: string; step: number };
  // }>({})
  const [combinedMultiplesState, setCombinedMultiplesState] = useState<MulitipleItem1[]>(defaultCombinedMultiples);
  const [files, setFiles] = useState<{ id: number; file: File; preview: string }[]>([]);
  const [files2, setFiles2] = useState<FileItem22[]>([]);
  // const [files2, setFiles2] = useState<{ id: number; file: File; preview: string }[]>([]);
  const [files3, setFiles3] = useState<{ id: number; file: File; preview: string }[]>([]);
  const [files4, setFiles4] = useState<
    { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[]
  >([]);
  // const [files4, setFiles4] = useState<{ id: number; file: File; preview: string; imageUrl: string }[]>([]);

  const { id } = useParams();
  const [step1data, setstep1data] = useState<any[]>([]);
    const [alldefaultvalues, setdefaultvalues] = useState<any[]>([]);
  const [currentlength, setcurrentlength] = useState(0);
  const [step1data2, setstep1data2] = useState<any[]>([]);
   const [step1data2default, setstep1data2default] = useState<any[]>([]);
   
      const [step1data2defaultchekbox, setstep1data2defaultchekbox] = useState<any[]>([]);
  const [allinone, setallinone] = useState<any[]>([]);
    const [allhintsteps, setallhitssteps] = useState<any[]>([]);
  const [uploadedImages, setUploadedImages] = useState<{ [key: number]: string }>({});

  const [stepOneMultiples, setStepOneMultiples] = useState<MulitipleItemdd[]>([]);
  const [transfer22, settransfer22] = useState<any>(null);
  const [showImageUploadBanner, setShowImageUploadBanner] = useState(false);
  const [test22, settest22] = useState("");
  const [longDescriptions, setLongDescriptions] = useState<{ [key: string]: string }>({});
  const [longDescriptionsHi, setLongDescriptionsHi] = useState<{ [key: string]: string }>({});

  const [checkboxItems, setCheckboxItems] = useState<{ [key: number]: CheckboxItem[] }>({}); // Updated type

  const [selectedItems, setSelectedItems] = useState<
    { id: number; value: string; idid: number }[]
  >([]);
 const [selectedOption1, setSelectedOption1] = useState<string>("");
  const [selectedmcq, setSelectedmcq] = useState('');
  // const [selectedmcq22, setSelectedmcq22] = useState<{ [key: number]: string }>({});
const [selectedmcq22, setSelectedmcq22] = useState<Record<number, string>>({});
    // const [defaultipostermages, setdefaultipostermages] = useState('');
    const [defaultipostermages, setdefaultipostermages] = useState<string[]>([]); // Fixed initialization
        const [defaulttaskiconimages, setdefaulttaskiconimages] = useState<string[]>([]); // Fixed initialization

  const [imagesdata, setimagesdata] = useState<{ id: number; images: string[] }[]>([]);
  const [imagesdata3, setimagesdata3] = useState<{ id: number; images: string[] }[]>([]);
  const [imagesdata1, setimagesdata1] = useState<{ id: number; images: string[] }[]>([]);
  const [activeStep, setActiveStep] = useState<number>(1);
  const [finalll, setfinalll] = useState<string[]>([]);  // const { sectionsData22, setSectionsData22 } = useTaskContext();

  // availability state
  const [instructionImageMap, setInstructionImageMap] = useState<
    { mainId: number; instructionId: number; image: string; hint_id: string; primarykeyid: number }[]
  >([]);


  const [test22Value, setTest22Value] = useState<Record<number, string>>({});


  const [textValueData, setTextValueData] = useState<{ id: number; value: string }[]>([]);

  const [textValueData44, setTextValueData44] = useState<{ id: number; value: string }[]>([]);


  const [textValueDatadefault, setTextValueDatadefault] = useState<{ id: number; value: string }[]>([]);
  
    const [textValueDatadefaulthindi, setTextValueDatadefaulthindi] = useState<{ id: number; value: string }[]>([]);

  const [textValueHiData, setTextValueHiData] = useState<{ id: number; value: string }[]>([]);

  const [valueArray, setValueArray] = useState<{ mainid: number; index: number; value: string; hint_id: string; primarykeyid: number }[]>([]);
  const [valueHiArray, setValueHiArray] = useState<{ mainid: number; index: number; value: string; hint_id: string; primarykeyid: number }[]>([]);


  const [Tabname, setTabname] = useState("");
  const [fileName, setfileName] = useState("");
  const [finalvalue, setfinalvalue] = useState("");
  const [showNoTask, setShowNoTask] = useState(false);
  const [correctHintArray, setCorrectHintArray] = useState<{ id: number; index: number; value: string, hint_id: string }[]>([]);
  const [correctHintHiArray, setCorrectHintHiArray] = useState<{ id: number; index: number; value: string, hint_id: string }[]>([]);

  const [educationalData, seteducationalData] = useState<SectionData[]>([]);
  const [sectionsData, setSectionsData] = useState<SectionData[]>([]);
  const [currentLang, setCurrentLang] = useState<any>("en");
  console.log(currentLang, "currentLangcurrentLang")
  const [currentData, setCurrentData] = useMemo(() => {
    return (
      Tabname === "Educational task" ||
      Tabname === "शैक्षिक कार्य" ||
      Tabname === "शैक्षणिक कार्य" ||
      Tabname === "Survey Task" ||
      Tabname === "सर्वेक्षण" ||
      Tabname === "Feedback Task" ||
      Tabname === "प्रतिक्रिया" ||
      Tabname=== "Image Capture Task" ||
      Tabname=== "छवि कैप्चर कार्य" ||
      Tabname === "Dotcode Scanning Task" ||
      Tabname === "डॉटकोड स्कैनिंग कार्य"

    )
      ? [educationalData, seteducationalData]
      : [sectionsData, setSectionsData];
  }, [Tabname, educationalData, sectionsData]);

  console.log(sectionsData, "55555555888888****")
  console.log(currentData, "currentDatacccc", Tabname, "mmmmmmmmmmmmmmmmm")
  console.log(combinedMultiplesState, "combinedMultiplesStatecombinedMultiplesState")
console.log(selectedmcq22, "selectedmcq22788888556666666")
  const [multiples99, setMultiples2299] = useState<any[]>([]); // or type it if you have a type
  const [multiples888, setMultiples888] = useState<any[]>([]);
  const [multiplesStep66, setMultiplesStep66] = useState<any[]>([]);
  const [multiplesStep77, setMultiplesStep77] = useState<any[]>([]);
  console.log(multiples99, "5577777777777777777777")
  // useEffect(() => {
  //   if (activeStep === 1 && multiples99.length === 0) {
  //     const baseMultiples = [
  //       { id: 1, value: "", checkvalue: "A", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
  //       { id: 2, value: "", checkvalue: "B", value_hi: "", smallimage: "", bigimage: "" },
  //       { id: 3, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
  //       { id: 4, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
  //       { id: 5, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
  //     ];

  //     const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
  //     const combined = [
  //       ...baseMultiples,
  //       ...previousMultiples.map((m, index) => ({
  //         ...m,
  //         id: baseMultiples.length + index + 1, // ensure unique ID
  //       })),
  //     ];

  //     setMultiples2299(combined);
  //   }
  // }, [sectionsData, activeStep]);

  // useEffect(() => {
  //   if (activeStep === 2 && multiples888.length === 0) {
  //     const baseMultiples = [
  //       { id: 1, value: "", checkvalue: "X", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
  //       { id: 2, value: "", checkvalue: "Y", value_hi: "", smallimage: "", bigimage: "" },
  //       { id: 3, value: "", checkvalue: "Z", value_hi: "", smallimage: "", bigimage: "" },
  //     ];

  //     const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
  //     const combined = [
  //       ...baseMultiples,
  //       ...previousMultiples.map((m, index) => ({
  //         ...m,
  //         id: baseMultiples.length + index + 1,
  //       })),
  //     ];

  //     setMultiples888(combined);
  //   }
  // }, [sectionsData, activeStep]);


  console.log(multiples99,)
  function buildQuestion(id: number, isMultipleChoice: boolean, instructions: InstructionItem[]): SectionData {
    return {
      id,
      initialName: `Question ${id}`,
      placeholder: "Your name",
      markerImage: marker,
      typographyText: "Page 1",
      textValue: "",
      textValue_hi: "",
      language: currentLang,
      main_question_id:"",
      iconimage: "",
      smallquestionsimage: [],
      mainplaceholder: "Write your question here",

      selectValue: selectedmcq || (isMultipleChoice ? "multiplechoice" : ""),
      optionsslectedvalue: null,
      finalcorr: "",
      correcthint: "",
      correcthint_hi: "",
      idid1: 0,
      taskimage: "",
      test245: "",
      taskinstructions: [{ id: 1, value: "", image: "" }],
      dropdownOptions: isMultipleChoice
        ? [{ id: 2, label: "Single Answer Selection", value: "multiplechoice" }]
        : [
          { id: 2, label: "Single Answer Selection", value: "" },
          { id: 3, label: "Multiple Answer Selection", value: "checkbox" },
          // { id: 4, label: "Ratings Scale", value: "ratings" },
          { id: 5, label: "MCQ Image", value: "mcqimage" },
          { id: 6, label: "Long / Short Description", value: "longshortdescription" },
        ],
      instructions: instructions.map(dd => ({
        id: dd.id,
        value: "",
        value_hi: "",
        smallimage: "",
        bigimage: "",
      })),
      Multiples: [
        { id: 1, value: "", value_hi: "", checkvalue: "A", smallimage: "", bigimage: "" },
        { id: 2, value: "", value_hi: "", checkvalue: "B", smallimage: "", bigimage: "" },
        { id: 3, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
        { id: 4, value: "", value_hi: "", checkvalue: "D", smallimage: "", bigimage: "" },
        { id: 5, value: "", value_hi: "", checkvalue: "E", smallimage: "", bigimage: "" },
      ],
      Checkboxes: [
        { id: 1, value: "", checked: false },
        { id: 2, value: "", checked: false },
        { id: 3, value: "", checked: false },
      ],
      rating: { initialStars: 0, maxStarsOptions: [5, 6, 7, 8, 9, 10] },
    };
  }

  useEffect(() => {
    if (currentlength > 0 && !id) {
      setCurrentData(
        Array.from({ length: currentlength }).map((_, index) =>
          buildQuestion(index + 1, false, [])
        )
      );
    }
  }, [currentlength, id, currentLang, selectedmcq]); // Add selectedmcq as dependency
  // -------------------- DERIVE engLang BASED ON DATA --------------------
  // -------------------- DERIVE engLang BASED ON DATA + currentlength --------------------
  const engLang: SectionData[] = useMemo(() => {
    if (sectionsData.length > 0) {
      return sectionsData.map((item, index) =>
        buildQuestion(index + 1, item.selectValue === "multiplechoice", item.instructions || [])
      );
    } else if (educationalData.length > 0) {
      return educationalData.map((item, index) =>
        buildQuestion(index + 1, item.selectValue === "multiplechoice", item.instructions || [])
      );
    } else if (currentlength > 0) {
      // Use currentlength to create that many default questions
      return Array.from({ length: currentlength }).map((_, index) =>
        buildQuestion(index + 1, false, [])
      );
    } else {
      // Default single question
      return [buildQuestion(1, false, [])];
    }
  }, [sectionsData, educationalData, currentLang, currentlength]);

  useEffect(() => {
    if (currentlength > 0 && !id) {
      setCurrentData(Array.from({ length: currentlength }).map((_, index) =>
        buildQuestion(index + 1, false, [])
      ));
    }
  }, [currentlength, id, currentLang]);



  console.log(engLang, "engLangengLangengLangengLang")
  console.log(currentlength, "currentlengthcurrentlengthcurrentlength")

  // if (currentlength > 0) {
  //   engLang = Array.from({ length: currentlength }).map((_, index) => {
  //     const isMultipleChoice = false;
  //     return buildQuestion(index + 1, isMultipleChoice, []);
  //   });
  // }


  console.log(currentlength, "currentlengthwww")
  console.log(currentData, "checkcheckcheckcheckddddddddd")
  const hindiLang = currentData.map((item) => {
    const isMultipleChoice = item.selectValue === "multiplechoice";
    console.log(engLang, "55555engLangengLang")
    return {
      id: item.id,
      initialName: `प्रश्न ${item.id}`,
      placeholder: "आपका नाम",
      markerImage: marker,
      typographyText: "पृष्ठ 1",
      textValue: "ccccccccc",
      language: "hi",
        main_question_id:"",
      textValue_hi: "",
      mainplaceholder: "अपना प्रश्न यहाँ लिखें",
      selectValue: item.selectValue || "",
      optionsslectedvalue: "",
      finalcorr: "",
      correcthint: "",
      correcthint_hi: "",
      smallquestionsimage: [],
      idid1: 0,
      taskimage: "",
      iconimage: "",
      test245: "",
      taskinstructions: Array.from({ length: currentData.find(cd => cd.id === item.id)?.taskinstructions.length || 1 }, (_, i) => ({
        id: i + 1,
        value: "",
        image: ""
      })),

      dropdownOptions: isMultipleChoice
        ? [{ id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" }]
        : [
          // { id: 1, label: "चित्र लें", value: "" },
          { id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" },
          { id: 3, label: "एकाधिक उत्तर चयन", value: "" },
          { id: 4, label: "रेटिंग स्केल", value: "raatings" },
          { id: 5, label: "एमसीक्यू छवि", value: "mcqimage" },
          { id: 5, label: "लंबा / संक्षिप्त विवरण", value: "longshortdescription" },
        ],
      // instructions: [
      //   { id: 1, value: "",value_hi:"", smallimage: "", bigimage: "" },
      // ],
      instructions: Array.from(
        { length: currentData.find(cd => cd.id === item.id)?.instructions.length || 1 },
        (_, i) => ({
          id: i + 1,
          value: "",
          value_hi: "",
          smallimage: "",
          bigimage: ""
        })
      ),
      Multiples: [
        { id: 1, value: "", value_hi: "", checkvalue: "A", smallimage: "", bigimage: "" },
        { id: 2, value: "", value_hi: "", checkvalue: "B", smallimage: "", bigimage: "" },
        { id: 3, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
        { id: 4, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
        { id: 5, value: "", value_hi: "", checkvalue: "C", smallimage: "", bigimage: "" },
      ],
      Checkboxes: [
        { id: 1, value: "", checked: false },
        { id: 2, value: "", checked: false },
        { id: 3, value: "", checked: false },
      ],
      rating: {
        initialStars: 0,
        maxStarsOptions: [5, 6, 7, 8, 9, 10],
      },
    };
  });


  // hindiLang.forEach((item) => {
  //   item.dropdownOptions =
  //     item.selectValue === "multiplechoice"
  //       ? [
  //           { id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" },
  //         ]
  //       : [
  //           { id: 1, label: "चित्र लें", value: "" },
  //           { id: 2, label: "एकल उत्तर चयन", value: "multiplechoice" },
  //           { id: 3, label: "एकाधिक उत्तर चयन", value: "checkbox" },
  //           { id: 4, label: "रेटिंग स्केल", value: "ratings" },
  //         ];
  // });

  const maritiLang = [
    {
      id: 1,
      initialName: currentLang,
      placeholder: "तुमचे नाव",
      markerImage: marker,
      typographyText: "पृष्ठ 1",
      textValue: "",
      textValue_hi: "",
      mainplaceholder: "इथे तुमचा प्रश्न लिहा",
      selectValue: "",
      iconimage: "",
      smallquestionsimage: [],
      optionsslectedvalue: "",
      finalcorr: "",
      correcthint: "",
      correcthint_hi: "",
      idid1: 0,
      taskimage: "",
      test245: "",
      taskinstructions: [{ id: 1, value: "", image: "" }], dropdownOptions: [
        { id: 1, label: "चित्र काढा", value: "" },
        { id: 2, label: "एकच उत्तर निवडा", value: "multiplechoice" },
        { id: 3, label: "अनेक उत्तरे निवडा", value: "checkbox" },
        { id: 4, label: "रेटिंग स्केल", value: "ratings" },
        { id: 5, label: "रेटिंग स्केल", value: "mcqimage" },
        { id: 6, label: "लंबा / संक्षिप्त विवरण", value: "longshortdescription" },
      ],
      instructions: [
        { id: 1, value: "", smallimage: "", bigimage: "" },
      ],
      Multiples: [
        { id: 1, value: "", checkvalue: "अ", smallimage: "", bigimage: "" },
        { id: 2, value: "", checkvalue: "ब", smallimage: "", bigimage: "" },
        { id: 3, value: "", checkvalue: "क", smallimage: "", bigimage: "" },
        { id: 4, value: "", checkvalue: "ड", smallimage: "", bigimage: "" },
        { id: 5, value: "", checkvalue: "इ", smallimage: "", bigimage: "" },
      ],
      Checkboxes: [
        { id: 1, value: "", checked: false },
        { id: 2, value: "", checked: false },
        { id: 3, value: "", checked: false },
      ],
      rating: {
        initialStars: 0,
        maxStarsOptions: [5, 6, 7, 8, 9, 10],
      },
    },
    {
      id: 2,
      initialName: "प्रश्न 2",
      placeholder: "तुमचे नाव",
      markerImage: marker,
      typographyText: "पृष्ठ 2",
      textValue: "",
      textValue_hi: "",
      taskimage: "", iconimage: "",
      smallquestionsimage: [],
      mainplaceholder: "इथे तुमचा प्रश्न लिहा",
      selectValue: "",
      optionsslectedvalue: "",
      finalcorr: "",
      correcthint: "",
      correcthint_hi: "",
      idid1: 0,

      test245: "",
      taskinstructions: [{ id: 1, value: "", image: "" }],
      dropdownOptions: [
        { id: 1, label: "चित्र काढा", value: "" },
        { id: 2, label: "एकच उत्तर निवडा", value: "multiplechoice" },
        { id: 3, label: "अनेक उत्तरे निवडा", value: "checkbox" },
        { id: 4, label: "रेटिंग स्केल", value: "ratings" },
        { id: 5, label: "रेटिंग स्केल", value: "mcqimage" },
        { id: 6, label: "लंबा / संक्षिप्त विवरण", value: "longshortdescription" },
      ],
      instructions: [
        { id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" },
      ],
      Multiples: [
        { id: 1, value: "", checkvalue: "अ", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
        { id: 2, value: "", checkvalue: "ब", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
        { id: 3, value: "", checkvalue: "क", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
        { id: 4, value: "", checkvalue: "ड", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
        { id: 5, value: "", checkvalue: "इ", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
      ],
      Checkboxes: [
        { id: 1, value: "", checked: false },
        { id: 2, value: "", checked: false },
        { id: 3, value: "", checked: false },
      ],
      rating: {
        initialStars: 0,
        maxStarsOptions: [5, 6, 7, 8, 9, 10],
      },
    },
  ];
  //End  Availablity, Education


  //   useEffect(() => {
  //     const getLanguageData = () => {
  //       switch (currentLang) {
  //         case "en":
  //           return engLang;
  //         case "mr":
  //           return maritiLang;
  //         case "hi":
  //           return hindiLang;
  //         default:
  //           return engLang;
  //       }
  //     };
  //     setSectionsData(getLanguageData() as SectionData[]);
  // seteducationalData(getLanguageData() as SectionData[]);
  // settargetData(getLanguageData() as SectionData[]);

  //   }, [currentLang]);


  const prevLangRef = useRef<string>();

  useEffect(() => {
    // Skip if language hasn't changed
    if (prevLangRef.current === currentLang) return;

    const getLanguageData = () => {
      switch (currentLang) {
        case "en": return engLang;
        case "mr": return maritiLang;
        case "hi": return hindiLang;
        default: return engLang;
      }
    };

    const langData = getLanguageData();
    setSectionsData(langData as SectionData[]);
    seteducationalData(langData as SectionData[]);
    settargetData(langData as SectionData[]);

    // Update ref with current language
    prevLangRef.current = currentLang;
  }, [currentLang]);



  // const [sectionsData, setSectionsData] = useState<SectionData[]>(finalLang);

  // educations task
  console.log(sectionsData, currentLang, "xxxxxxxxxxxxxx")
  // const [educationalData, seteducationalData] = useState<SectionData[]>([]);
  // target task
  const [targetData, settargetData] = useState<SectionData[]>([]);

  //   const [multiples99, setMultiples2299] = useState<any[]>([]); // or type it if you have a type
  //   const [multiples888, setMultiples888] = useState<any[]>([]);
  //   const [multiplesStep66, setMultiplesStep66] = useState<any[]>([]);
  // const [multiplesStep77, setMultiplesStep77] = useState<any[]>([]);
  // console.log(multiples99, "5577777777777777777777")
  //   useEffect(() => {

  //     if (activeStep === 1) {
  //       const baseMultiples = [
  //         { id: 1, value: "", checkvalue: "A", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
  //         { id: 2, value: "", checkvalue: "B", value_hi: "", smallimage: "", bigimage: "" },
  //         { id: 3, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
  //         { id: 4, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
  //         { id: 5, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "" },
  //       ];

  //       const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
  //       const combined = [
  //         ...baseMultiples,
  //         ...previousMultiples.map((m, index) => ({
  //           ...m,
  //           id: baseMultiples.length + index + 1, // ensure unique ID
  //         })),
  //       ];

  //       setMultiples2299(combined);
  //     }
  //   }, [sectionsData, activeStep]);
  //   useEffect(() => {
  //     if (activeStep === 2) {
  //       const baseMultiples = [
  //         { id: 1, value: "", checkvalue: "X", value_hi: "", smallimage: "", bigimage: "", mainid: 0 },
  //         { id: 2, value: "", checkvalue: "Y", value_hi: "", smallimage: "", bigimage: "" },
  //         { id: 3, value: "", checkvalue: "Z", value_hi: "", smallimage: "", bigimage: "" },
  //       ];

  //       const previousMultiples = sectionsData.flatMap(section => section.Multiples || []);
  //       const combined = [
  //         ...baseMultiples,
  //         ...previousMultiples.map((m, index) => ({
  //           ...m,
  //           id: baseMultiples.length + index + 1,
  //         })),
  //       ];

  //       setMultiples888(combined);
  //     }
  //   }, [sectionsData, activeStep]);


  console.log(multiples99, "oooo4444%%%%%%%sssss%%%%%")

  let uyu = []

//   const getDropdownOptions = (selectedType: string | undefined) => {
//   const getLocalizedText = (text: { en: string; hi: string; mr: string }) => {
//     return currentLang === "hi" ? text.hi : currentLang === "mr" ? text.mr : text.en;
//   };
//   console.log(selectedType, "selectedTypessssssssswww")

//   // Default to single answer selection if selectedType is empty/undefined
//   if (!selectedType) {
//     return [
//       {
//         id: 2,
//         label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
//         value: "",
//       },
  
//         {
//           id: 3,
//           label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
//           value: "checkbox",
//         },
//         {
//           id: 5,
//           label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
//           value: "mcqimage",
//         },
//         {
//           id: 6,
//           label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
//           value: "longshortdescription",
//         },
//     ];
//   }

//   return selectedType === "multiplechoice"
//     ? [
//         {
//           id: 2,
//           label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
//           value: "multiplechoice",
//         },
//         {
//           id: 3,
//           label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
//           value: "checkbox",
//         },
//         {
//           id: 5,
//           label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
//           value: "mcqimage",
//         },
//         {
//           id: 6,
//           label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
//           value: "longshortdescription",
//         },
//       ]
//     : [
//         {
//           id: 2,
//           label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
//           value: "multiplechoice",
//         },
//         {
//           id: 3,
//           label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
//           value: "checkbox",
//         },
//         {
//           id: 5,
//           label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
//           value: "mcqimage",
//         },
//         {
//           id: 6,
//           label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
//           value: "longshortdescription",
//         },
//       ];
// };

const getDropdownOptions = (selectedType: string | undefined) => {
  const getLocalizedText = (text: { en: string; hi: string; mr: string }) => {
    return currentLang === "hi" ? text.hi : currentLang === "mr" ? text.mr : text.en;
  };

  console.log(selectedType, "selectedTypessssssssswww");

  // Define the dropdown options
  const dropdownOptions = [
    {
      id: 2,
      label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
      value: "", // Always empty for Single Answer Selection
    },
    {
      id: 3,
      label: getLocalizedText({ en: "Multiple Answer Selection", hi: "एकाधिक उत्तर चयन", mr: "अनेक उत्तरे निवड" }),
      value: "checkbox",
    },
    {
      id: 5,
      label: getLocalizedText({ en: "MCQ Image", hi: "एमसीक्यू छवि", mr: "एमसीक्यू प्रतिमा" }),
      value: "mcqimage",
    },
    {
      id: 6,
      label: getLocalizedText({ en: "Long / Short Description", hi: "लंबा / संक्षिप्त विवरण", mr: "लांब / संक्षिप्त वर्णन" }),
      value: "longshortdescription",
    },
  ];

  // If selectedType is "multiplechoice", filter to only show Single Answer Selection
  return selectedType === "multiplechoice"
    ? [
        {
          id: 2,
          label: getLocalizedText({ en: "Single Answer Selection", hi: "एकल उत्तर चयन", mr: "एकल उत्तर निवड" }),
          value: "", // Ensure it remains empty
        },
      ]
    : dropdownOptions; // Return all options for other cases
};
useEffect(() => {
  setCurrentData(prev =>
    prev.map(question => {
      const selectedType = selectedmcq22[question.id];
      const type = !selectedType || selectedType.trim() === "" ? "" : selectedType;
      return {
        ...question,
        selectValue: type,
        dropdownOptions: getDropdownOptions(type),
      };
    })
  );
}, [selectedmcq22, currentLang]);


console.log(currentData, "currentDataseeeeeeeeeee")

const addQuestionss = (tabName: string) => {
  const getLocalizedText = (text: { en: string; hi: string; mr: string }) => {
    return currentLang === "hi" ? text.hi : currentLang === "mr" ? text.mr : text.en;
  };

  const newQuestionId = (tabName === "Educational task" ? educationalData.length : sectionsData.length) + 1;
  const selectedType = selectedmcq22[newQuestionId] || "";

  // Get dropdown options
  const dropdownOptions = getDropdownOptions(selectedType);

  // Initialize Multiples for checkbox type
  const initialMultiples = selectedType === "checkbox"
    ? [
        { id: 1, value: "", checkvalue: "A", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
        { id: 2, value: "", checkvalue: "B", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
        { id: 3, value: "", checkvalue: "C", value_hi: "", smallimage: "", bigimage: "", ismatch: false },
      ]
    : [];

  const newQuestion: SectionData = {
    id: newQuestionId,
    initialName: getLocalizedText({ en: `Question ${newQuestionId}`, hi: `प्रश्न ${newQuestionId}`, mr: `प्रश्न ${newQuestionId}` }),
    placeholder: getLocalizedText({ en: "Your name", hi: "आपका नाम", mr: "तुमचे नाव" }),
    markerImage: marker,
    typographyText: `Page ${newQuestionId}`,
    textValue: "",
    textValue_hi: "",
    iconimage: "",
    mainplaceholder: getLocalizedText({ en: "Write your question here", hi: "अपना प्रश्न यहाँ लिखें", mr: "आपला प्रश्न येथे लिहा" }),
    selectValue: selectedType,
    smallquestionsimage: [],
    optionsslectedvalue: "",
    finalcorr: "",
    correcthint: "",
    correcthint_hi: "",
    idid1: 0,
    taskimage: "",
    test245: "",
    taskinstructions: [{ id: 1, value: "", image: "" }],
    dropdownOptions,
    instructions: [{ id: 1, value: "", value_hi: "", smallimage: "", bigimage: "" }],
    Multiples: initialMultiples,
    Checkboxes: initialMultiples.length
      ? initialMultiples.map(m => ({ id: m.id, value: "", checked: false }))
      : [
          { id: 1, value: "", checked: false },
          { id: 2, value: "", checked: false },
          { id: 3, value: "", checked: false },
        ],
    rating: { initialStars: 0, maxStarsOptions: [5, 6, 7, 8, 9, 10] },
    language: "",
    main_question_id: "",
  };

  if (tabName === "Educational task" || tabName === "शैक्षिक कार्य" || tabName === "शैक्षणिक कार्य") {
    seteducationalData(prev => [...prev, newQuestion]);
  } else {
    setSectionsData(prev => [...prev, newQuestion]);
  }
};

  // const [currentData, setCurrentData] = useMemo(() => {
  //   return (
  //     Tabname === "Educational task" ||
  //     Tabname === "शैक्षिक कार्य" ||
  //     Tabname === "शैक्षणिक कार्य"
  //   )
  //     ? [educationalData, seteducationalData]
  //     : [sectionsData, setSectionsData];
  // }, [Tabname, sectionsData, setSectionsData, educationalData, seteducationalData]);
  console.log(multiples99, "multiples99sssssssss")
  console.log(currentData, "sectionsDatasectionsDatasectionsData");
  const filteredSections = sectionsData.filter(item => item.textValue !== "" && item.textValue !== null);
  console.log(filteredSections, "Filtered sectionsData");
  const [state, setState] = useState<TaskState>({
    instructions: [{ id: 1, value: "", image: "" }],
    idid: 0,
    textname: "",
    multiples: [{ id: 0, value: "", checkvalue: "", smallimage: "", bigimage: "", ismatch: false }], // Ensure the correct type
    selectedValue: "",
    text: "",
    sectionsData: 0
  });

  return (
    <TaskContext.Provider
      value={{
        //Notes show
        step1data2defaultchekbox, setstep1data2defaultchekbox,
        step1data, setstep1data,
        step1data2, setstep1data2,
        step1data2default, setstep1data2default,
        setdefaultvalues,alldefaultvalues,
        combinedMultiplesState, setCombinedMultiplesState,
        files, setFiles,
        longDescriptionsHi, setLongDescriptionsHi,
        files2, setFiles2,
        files3, setFiles3,
        files4, setFiles4,
        multiples888, setMultiples888, multiples99, setMultiples2299,
        transfer22, settransfer22,
        uploadedImages, setUploadedImages,
        stepOneMultiples,
        setStepOneMultiples,
        setcurrentlength, currentlength,
        test22Value, setTest22Value,
        longDescriptions, setLongDescriptions,
        selectedmcq, setSelectedmcq,
        
        defaultipostermages, setdefaultipostermages,
        defaulttaskiconimages, setdefaulttaskiconimages,
        selectedOption1,setSelectedOption1,
        valueArray, setValueArray,
        valueHiArray, setValueHiArray,
        instructionImageMap,
        setInstructionImageMap,
        textValueData,
        setTextValueData,
        textValueDatadefault, setTextValueDatadefault,
        textValueDatadefaulthindi, setTextValueDatadefaulthindi,
        textValueData44,
        setTextValueData44,
        textValueHiData,
        setTextValueHiData,
        setCorrectHintArray,
        setCorrectHintHiArray,
        correctHintArray,
        correctHintHiArray,
        showNoTask,
        activeStep,
        setActiveStep,
        setCurrentData,
        currentData,
        setfinalll,
        setShowNoTask,
        finalll,
        setallinone, allinone,
        allhintsteps, setallhitssteps,
        test22, settest22,
        state,
        setState,
        setfinalvalue,
        finalvalue,
        setInstructions,
        instructions33,
        instructions33default, setInstructionsdefault,
        setTabname,
        Tabname,
        setfileName,
        fileName,

        //Notes show
        // sectionsData22,
        // setSectionsData22,
        // availability questions data
        sectionsData,
        setSectionsData,
        // availability questions data

        // eduacational questions data
        educationalData,
        seteducationalData,
        // eduacational questions data

        // availability questions data
        targetData,
        settargetData,
        // availability questions data
        setimagesdata1,
        imagesdata1,
        setimagesdata3,
        imagesdata3,
        imagesdata,
        setimagesdata,

        // Questions show
        addQuestionss,
        showImageUploadBanner,
        setShowImageUploadBanner,
        // Questions show
        currentLang,
        setCurrentLang,
        checkboxItems,
        setCheckboxItems,
        selectedItems, setSelectedItems,
        selectedmcq22, setSelectedmcq22
      }}
    >
      {children}
    </TaskContext.Provider>
  );
};

// Custom hooks
export const useTaskContext = () => {
  const context = useContext(TaskContext);
  if (!context) {
    throw new Error("useTaskContext must be used within an AppProvider");
  }
  return context;
};